module.exports = __webpack_public_path__ + "static/cer_dor_8-0a38eec5be077b240c1f148f04b4bee4.jpg";